import { Select } from 'antd'
import type { CSSProperties } from 'react'
import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import type { FlattenedMenuOption, MenuSearchOption, NavigationMenuItem } from './types'

interface MenuSearchProps {
  menuData: NavigationMenuItem[]
  style?: CSSProperties
}

/**
 * Normaliza string removendo acentos e convertendo para minúsculas
 * para comparação que ignora acentuação
 */
const normalizarString = (str: string): string => {
  if (!str) return ''
  return str
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase()
}

const flattenMenuItems = (items: NavigationMenuItem[], parents: string[] = []): FlattenedMenuOption[] => {
  let flattened: FlattenedMenuOption[] = []

  items.forEach((item) => {
    if (item.path) {
      const groupPath = parents.length > 0 ? `${parents.join(' > ')} > ` : ''
      flattened.push({
        key: item.path,
        value: item.path,
        label: item.label,
        fullLabel: `${groupPath}${item.label}`,
      })
    }

    if (item.subitems) {
      const newParents = [...parents]
      if (!item.path) {
        newParents.push(item.label)
      }
      flattened = flattened.concat(flattenMenuItems(item.subitems, newParents))
    }
  })

  return flattened
}

const MenuSearch = ({ menuData, style }: MenuSearchProps) => {
  const navigate = useNavigate()
  const [selectedKey, setSelectedKey] = useState<string | null>(null)

  const options = flattenMenuItems(menuData)

  const handleSelect = (value: string): void => {
    navigate(value)
    setSelectedKey(null)
  }

  const filterOption = (input: string, option?: MenuSearchOption): boolean => {
    if (!option) throw new TypeError("Cannot read properties of undefined (reading 'fullLabel')")

    const searchText = normalizarString(input)
    return normalizarString(option.fullLabel).includes(searchText)
  }

  const selectOptions: MenuSearchOption[] = options.map((option) => ({
    ...option,
    label: (
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          gap: '2px',
        }}
      >
        <div>{option.label}</div>
        {option.fullLabel !== option.label && (
          <div
            style={{
              fontSize: '12px',
              color: '#8c8c8c',
              fontStyle: 'italic',
            }}
          >
            {option.fullLabel}
          </div>
        )}
      </div>
    ),
  }))

  return (
    <Select<string, MenuSearchOption>
      showSearch
      placeholder="Busca rápida no menu"
      style={{ width: '300px', marginTop: '0px', marginLeft: '8px', ...style }}
      value={selectedKey}
      onSelect={handleSelect}
      filterOption={filterOption}
      options={selectOptions}
    />
  )
}

export default MenuSearch
